<template>
  <section
    :class="[$style.login, $style.fullscreen]"
    :style="{
      backgroundImage: 'url(\'resources/images/fondo-aol.jpg\')'
    }"
  >
    <header :class="$style.header">
      <a href="javascript: void(0);" :class="$style.logo">
        <img
          src="/resources/images/logo-membresia-aol.png"
          alt="El Arte de Vivir"
        />
      </a>
    </header>
    <div :class="$style.content">
      <div :class="$style.promo">
        <h1 class="mb-3 text-white">
          Suscripción:
          {{ subscription.name }}
        </h1>
        <p>
          Para completar la suscripción ingresa los datos de tu tarjeta de
          débito o crédito.
        </p>
      </div>

      <div :class="$style.formWrapper">
        <div :class="$style.form" v-if="subscriptionError">
          <p :class="$style.formTitle">
            Hubo un error al cargar la subscripción. <br /><span
              style="font-size:12px"
              >Por favor, volver a intentar.</span
            >
          </p>
        </div>
        <div :class="$style.form" v-else-if="subscriptionProcessed">
          <p :class="$style.formTitle">
            <a-icon type="like" /> Listo! Ya estás suscripto a
            {{ subscription.name }}. <br />
          </p>
          <div class="login-form">
            <a-button type="primary" href="http://www.elartedevivir.org"
              ><a-icon type="right" /> Continuar Navegando
            </a-button>
          </div>
        </div>
        <div :class="$style.form" v-else>
          <p :class="$style.formTitle">Ingresá tus datos</p>

          <customer-form
            v-if="subscription.uuid"
            ref="customerFormComponent"
            :subscriptionUUID="subscription.uuid"
          />

          <a-divider orientation="left">Datos de Pago</a-divider>

          <payment-form
            v-if="subscription"
            ref="paymentFormComponent"
            :mode="'2-step'"
            :showPrice="true"
            :showInstallments="false"
            :publicKey="subscription.account.publicKey"
          />

          <vue-recaptcha
            sitekey="6Lf47sUUAAAAAHzkc0paHmaLsN2kUA_5pv2ZIDwi"
            :loadRecaptchaScript="true"
            @verify="handleRecaptchaVerified"
          >
          </vue-recaptcha>

          <div class="form-actions">
            <a-button
              @click="handleSubmit"
              type="primary"
              html-type="submit"
              :class="$style.loginFormButton"
              :loading="submitLoading"
              size="large"
              icon="lock"
            >
              SUSCRIBIRME
            </a-button>
          </div>
        </div>
        <div :class="$style.sidebar">
          <p :class="$style.sidebarTitle">
            Suscripción:
          </p>
          <p :class="$style.sidebarSubTitle" style="line-height:1.3">
            {{ subscription.name }}
          </p>

          <p :class="$style.sidebarSubTitle" style="margin-bottom:1rem">
            <strong>Precio:</strong>
            ${{ subscription.amount }}
            <span v-if="subscription.account.gatewayId == 1">ARS</span>
            <span v-else-if="subscription.account.gatewayId == 2">USD</span> /
            <span v-if="subscription.frequencyId == 1">mes</span>
            <span v-if="subscription.frequencyId == 2">año</span>
            <br />
            <span v-if="subscription.freeTrialDays" style="font-weight:bold"
              >{{ subscription.freeTrialDays }} días de prueba sin cargo</span
            >
          </p>
          <!--<p :class="$style.sidebarSubTitle" style="margin-bottom:1rem">
            <i class="icmn-user mr-3" /> Usuario: <br />
            {{ email }}
            <span v-if="phone"
              ><br />
              Tel: {{ phone }}
            </span>
          </p>-->
          <!--<div :class="$style.sidebarFooter" style="margin-bottom:1rem">
            <span>
              <i class="icmn-location mr-3" />
              Argentina
            </span>
          </div>-->
          <div :class="$style.sidebarContent">
            <p>
              <strong>Términos y Condiciones:</strong><br />
              <span v-if="subscription.account.gatewayId == 1">
                Los datos ingresados son procesados directamente por el gateway
                de pagos Decidir Prisma<sup>&reg;</sup>. En caso de cambio de
                precios de servicio se notificará a los usuarios con un mes de
                anticipación. Puedes cancelar la suscripción en el momento en el
                que lo desees.
              </span>
              <span v-else>
                Los datos ingresados son procesados directamente por la pasarela
                de pagos Páguelo Fácil<sup>&reg;</sup>. En caso de cambio de
                precios de servicio se notificará a los usuarios con un mes de
                anticipación. Puedes cancelar la suscripción en el momento en el
                que lo desees.
              </span>
              <!--
              Visa, MasterCard, American Express, ArgenCard, BBPS, Cabal, Cabal
              Prisma, CoopePlus, CrediGuia, Credimás, Diners Club, Distribution,
              Favacard, Grupar, Italcred, MasterCard Prisma, Nativa, Nexo,
              Patagonia 365, Qida, Tarjeta Carrefour / Cetelem, Tarjeta
              Cencosud, Tarjeta Club Día, Tarjeta La Anónima, Tarjeta Naranja,
              Tarjeta Nevada, Tarjeta PymeNacion, Tarjeta Shopping, Tarjeta SOL,
              Tuya-->
            </p>
          </div>
        </div>
      </div>
    </div>
    <footer :class="$style.footer" style="text-align:center; margin-top:5rem">
      <span style="color:#ccc;">
        <img
          src="/resources/images/logo-membresia-aol.png"
          alt="El Arte de Vivir"
          width="120"
        /><br />
        <!-- Darregueyra 2390, Palermo Buenos Aires, Argentina.<br /> -->
        <a href="https://elartedevivir.org" target="_blank">elartedevivir.org</a
        ><br />
        Darregueyra 2390, Ciudad Autónoma de Buenos Aires, Argentina.
      </span>
      <!--<ul :class="$style.footerNav">
        <li>
          <a href="javascript: void(0);">Términos y Condiciones</a>
        </li>
        <li>
          <a href="javascript: void(0);">Compliance</a>
        </li>
        <li>
          <a href="javascript: void(0);">Confidencialidad</a>
        </li>
        <li>
          <a href="javascript: void(0);">Soporte</a>
        </li>
        <li>
          <a href="javascript: void(0);">Contacto</a>
        </li>
      </ul>-->
    </footer>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
import errors from "@/services/errors";
import VueRecaptcha from "vue-recaptcha";
import utils from "@/services/utils";
import Vue from "vue";
import gateway from "@/services/gateway";
import PaymentForm from "@/components/PaymentForm";
import CustomerForm from "@/components/CustomerForm";

export default {
  components: {
    PaymentForm,
    CustomerForm,
    VueRecaptcha
  },
  data: function() {
    return {
      //firstName: null,
      //lastName: null,
      //email: null,
      //phone: null,
      //DNI: null,
      linkToken: this.$route.params.linkToken,
      form: this.$form.createForm(this),
      loading: false,
      subscription: {},
      submitLoading: false,
      subscriptionError: false,
      recaptchaKey: null,
      customerFieldsDisabled: false,
      totalAmount: null,
      subscriptionProcessed: false
      //fullscreen: false,
      //backgroundNumber: 1
    };
  },
  methods: {
    ...mapActions({
      loadSubscription: "subscriptionLink/load",
      subscribe: "subscriptionLink/subscribe"
    }),
    handleRecaptchaVerified(key) {
      this.recaptchaKey = key;
    },
    async handleSubmit(e) {
      //this.form.preventDefault();
      this.submitLoading = true; //local loader button
      this.$refs.paymentFormComponent.enableSubmitLoader();
      //validates fields and if !error calls decidir tokenize card endpoint
      const paymentFormPayload = await this.$refs.paymentFormComponent.handleSubmit();
      const customerFormPayload = await this.$refs.customerFormComponent.handleSubmit();
      const x = 10;
      if (paymentFormPayload && customerFormPayload) {
        if (!this.recaptchaKey) {
          this.$notification["warning"]({
            message: "Error",
            description: "Por favor, hacer click en el botton de Recaptcha."
          });
        } else {
          try {
            this.submitLoading = true;
            const res = await this.subscribe({
              paymentFormPayload,
              customerFormPayload,
              recaptcha: this.recaptchaKey,
              linkToken: this.linkToken
            });
            this.submitLoading = false;
            this.$notification["success"]({
              message: "La suscripción fue procesada con éxito."
            });
            if (this.subscription.successfulPaymentURL)
              window.location.href = this.subscription.successfulPaymentURL;
            else {
              this.subscriptionProcessed = true;
              window.scrollTo(0, 0);
            }
          } catch (err) {
            let description;
            if (err.message) description = err.message;
            else
              description =
                "Error al procesar el pago. Por favor, intente denuevo.";
            this.submitLoading = false;
            this.$notification["warning"]({
              message: "Error",
              description: description
            });
          }
        }
      }
      this.submitLoading = false;
    },
    goBack() {
      window.history.back();
    }
  },
  async created() {
    try {
      const res = await this.loadSubscription(this.$route.params.linkToken);
      this.subscription = store.state.subscriptionLink.subscription;
      store.state.paymentForm.subtotal = this.subscription.amount;
      this.totalAmount = utils.formatPrice(this.subscription.amount);
    } catch (error) {
      this.subscriptionError = true;
      this.$notification["warning"]({
        message: "Error",
        description: error.message
      });
    }
  },
  async mounted() {
    // this.$refs.paymentFormComponent.updateMainSubtotal(
    //   this.subscription.amount
    // );
  }
};
</script>

<style type="text/css">
.form-actions {
  padding-top: 0rem;
}
</style>

<style lang="scss" module>
@import "./style.module.scss";
.ant-select-dropdown {
  width: auto;
}
.ant-select-dropdown-menu {
  max-height: auto;
}
</style>

<style lang="css">
.email-search .ant-input-group-addon {
  top: -1px;
}
.ant-input-group-addon {
  color: rgba(0, 0, 0, 0.45);
  background-color: #f4f4f4;
}
.ant-input {
  height: inherit !important;
}
::placeholder {
  /* WebKit browsers */
  color: red;
  opacity: 1 !important;
}
</style>
